"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceSubscriptionDataContext = exports.defaultReplaceSubscriptionDataContextValue = exports.ReplaceSubscriptionDataProvider = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const defaultReplaceSubscriptionDataContextValue = exports.defaultReplaceSubscriptionDataContextValue = {
  droppingId: undefined,
  isSubscriptionReplacement: false,
  subscriptionId: undefined
};
const replaceSubscriptionDataContext = exports.replaceSubscriptionDataContext = /*#__PURE__*/(0, _react.createContext)(defaultReplaceSubscriptionDataContextValue);
const {
  Provider
} = replaceSubscriptionDataContext;
const ReplaceSubscriptionDataProvider = ({
  children,
  value
}) => {
  const {
    droppingId,
    subscriptionId
  } = value ?? {};
  const isSubscriptionReplacement = droppingId !== undefined && subscriptionId !== undefined;
  const contextValue = (0, _react.useMemo)(() => value ? {
    droppingId,
    isSubscriptionReplacement,
    subscriptionId
  } : defaultReplaceSubscriptionDataContextValue, [droppingId, isSubscriptionReplacement, subscriptionId, value]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: contextValue,
    children: children
  });
};
exports.ReplaceSubscriptionDataProvider = ReplaceSubscriptionDataProvider;